import { useEffect, useState } from "react";
import { TextInput } from "../../Components";

export default function AddInfluencer({ infError, error, data, setData, setInput, startDate, endDate, status, onDuplicateHandlesChange, mode }) {

    const [totalToken, setTotalToken] = useState(0);
    const [isDisabled, setIsDisabled] = useState((startDate !== "" && endDate !== "") ? false : true);
    const [duplicateHandles, setDuplicateHandles] = useState([]);

    const diffInDaysCount = (dt2, dt1) => {
        if (dt2 !== "" && dt1 !== "") {
            let findDiffInDays = Math.floor(
                (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
                    Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
                (1000 * 60 * 60 * 24)
            );
            return findDiffInDays;
        }
    }

    const checkDuplicateHandles = (currentData) => {
        const handles = currentData.map(item => (item.infHandle || item.influencer_handle || '').trim().toLowerCase());
        const duplicateIndices = [];

        handles.forEach((handle, index) => {
            // Only mark the last occurrence of duplicate handles
            if (handle && handles.lastIndexOf(handle) === index && handles.indexOf(handle) !== index) {
                duplicateIndices.push(index);
            }
        });

        setDuplicateHandles(duplicateIndices);

        // Notify parent component about duplicate status
        if (onDuplicateHandlesChange) {
            onDuplicateHandlesChange(duplicateIndices.length > 0);
        }

        return duplicateIndices.length > 0;
    };

    const handleAddRow = () => {
        const currentData = data || [];
        if (startDate !== "" && endDate !== "") {
            const dt1 = new Date(startDate);
            const dt2 = new Date(endDate);
            let findDiffInDays = 0;
            findDiffInDays = diffInDaysCount(dt2, dt1);
            setData([...currentData, {
                key: Date.now(),
                hash_tag: '',
                hashtag: '',
                influencer_handle: '',
                infHandle: '',
                token: (Number(findDiffInDays) + 1)
            }]);
        } else {
            setData([...currentData, {
                key: Date.now(),
                hash_tag: '',
                hashtag: '',
                influencer_handle: '',
                infHandle: '',
                token: "-"
            }]);
        }

        if (startDate !== "" && endDate !== "") {
            const dt1 = new Date(startDate);
            const dt2 = new Date(endDate);
            let findDiffInDays = 0;
            findDiffInDays = diffInDaysCount(dt2, dt1);
            let totalToken = findDiffInDays + 1;
            currentData.forEach(item => {
                totalToken = totalToken + item.token;
            })
            setTotalToken(totalToken)
        }

        // Revalidate for duplicates after adding row
        setTimeout(() => {
            checkDuplicateHandles([...currentData, { key: Date.now(), hash_tag: '', hashtag: '', influencer_handle: '', infHandle: '', token: "-" }]);
        }, 0);
    };

    const removeRow = (index) => {
        const currentData = data || [];
        const newArray = [...currentData];
        newArray.splice(index, 1);
        setData(newArray);
        if (startDate !== "" && endDate !== "") {
            let totalToken = 0
            newArray.forEach(item => {
                totalToken = totalToken + item.token;
            })
            setTotalToken(totalToken)
        }

        // Revalidate for duplicates after removing row
        checkDuplicateHandles(newArray);
    };

    const handleChange = (event, index, name) => {
        const currentData = data || [];
        let findDiffInDays = 0;
        if (startDate !== "" && endDate !== "") {
            const dt1 = new Date(startDate);
            const dt2 = new Date(endDate);
            findDiffInDays = diffInDaysCount(dt2, dt1);
        }
        const updatedData = [...currentData];
        if (name === "hashtag") {
            updatedData[index].hash_tag = event.target.value;
            updatedData[index].hashtag = event.target.value; // Update both
        } else {
            updatedData[index].influencer_handle = event.target.value;
            updatedData[index].infHandle = event.target.value; // Update both
        }
        if (startDate !== "" && endDate !== "") {
            updatedData[index].token = Number(findDiffInDays) + 1;
        } else {
            updatedData[index].token = "-";
        }
        setData(updatedData);

        // Check for duplicates after handle change
        if (name !== "hashtag") {
            checkDuplicateHandles(updatedData);
        }
    };

    const isStartDateToday = () => {
        if (!startDate) return false;
        const today = new Date();
        const start = new Date(startDate);
        today.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        return start.getTime() === today.getTime();
    };

    useEffect(() => {

        setIsDisabled(status === 'archived' || (mode === 'edit' && isStartDateToday()));

        // Ensure there's always at least one row to show the fields
        if (!data || data.length === 0) {
            console.log("🚀 Setting default data");
            setData([{
                key: Date.now(),
                infHandle: "",
                influencer_handle: "",
                hash_tag: "",
                hashtag: "",
                token: "-"
            }]);
            return;
        }



        // Check if dates are valid before processing
        if (startDate && endDate && startDate !== "" && endDate !== "") {
            const dt1 = new Date(startDate);
            const dt2 = new Date(endDate);

            // Validate that dates are valid
            if (!isNaN(dt1.getTime()) && !isNaN(dt2.getTime())) {
                let findDiffInDays = diffInDaysCount(dt2, dt1);
                let newData = [];
                let totalToken = 0;

                if (data && data.length > 0) {
                    data.forEach(item => {
                        item.token = Number(findDiffInDays) + Number(1);
                        newData.push(item)
                        totalToken = totalToken + item.token;
                    })
                    setData(newData)
                    setTotalToken(totalToken)
                }
            } else {
                setTotalToken("-")
            }
        } else {
            setTotalToken("-")
        }
        // eslint-disable-next-line 
    }, [startDate, endDate, status])

    return (
        <div className="space-y-4">
            <div className="space-y-4">
                {(data && data.length > 0 ? data : [{ key: Date.now(), infHandle: "", hash_tag: "", token: "-" }]).map((item, index) => {
                    return (
                        <div key={item.key} className={`flex flex-col md:flex-row items-start md:items-end gap-4 p-6  rounded-xl border border-gray-100 relative group transition-all hover:border-emerald-100 hover:bg-emerald-50/10 ${isDisabled ? '!bg-white' : 'bg-gray-50'}`}>
                            <div className="w-full md:flex-1">
                                <TextInput
                                    type="text"
                                    label={index === 0 ? "Handle" : ''}
                                    value={item.infHandle || item.influencer_handle || ''}
                                    errorText="Please enter Handle"
                                    placeholder="e.g. myhandle"
                                    onChange={(event) => handleChange(event, index, 'handle')}
                                    readOnly={isDisabled}
                                    isRequired
                                    error={infError && !(item.infHandle || item.influencer_handle)}
                                    className={`${isDisabled ? '!bg-gray-50' : ''}`}
                                />
                                {duplicateHandles.includes(index) && (item.infHandle || item.influencer_handle) && (
                                    <div className="input__error !mt-[-4px] !ml-5 !text-sm !text-red-600">
                                        The selected handle has already been added.
                                    </div>
                                )}
                            </div>
                            <div className="w-full md:flex-1">
                                <TextInput
                                    type="text"
                                    label={index === 0 ? "hashtag(s)" : ''}
                                    value={item.hash_tag || item.hashtag || ''}
                                    errorText="Please enter Hashtag"
                                    placeholder="e.g. #mytag, #youtag"
                                    onChange={(event) => handleChange(event, index, 'hashtag')}
                                    readOnly={isDisabled}
                                    isRequired
                                    error={infError}
                                    className={`${isDisabled ? '!bg-gray-50' : ''}`}
                                />
                            </div>
                            <div className="w-full md:w-32">
                                <TextInput
                                    type="text"
                                    label={index === 0 ? "Token Needed" : ''}
                                    readOnly={true}
                                    value={item.token}
                                    className={`bg-gray-100 ${isDisabled ? '!bg-gray-50' : ''}`}
                                />
                            </div>
                            <div className="flex items-center gap-2 md:pb-1">
                                <button
                                    title="Add New Row"
                                    className={`p-2.5 text-emerald-600 border border-emerald-200 rounded-lg hover:bg-emerald-50 transition-colors disabled:opacity-50  ${isDisabled ? '!bg-gray-50' : 'bg-white '}`}
                                    onClick={() => handleAddRow()}
                                    disabled={isDisabled}
                                >
                                    <div className="w-5 h-5 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    </div>
                                </button>
                                <button
                                    disabled={(data && data.length === 1) || isDisabled}
                                    title="Delete Row"
                                    className={`p-2.5 text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors disabled:opacity-50 ${isDisabled ? '!bg-gray-50' : 'bg-white '}`}
                                    onClick={() => removeRow(index)}
                                >
                                    <div className="w-5 h-5 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="mt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-4 bg-emerald-50 rounded-xl border border-emerald-100">
                <div className="flex items-center gap-2 text-sm text-emerald-800 italic">
                    <span className="text-red-500 font-bold not-italic font-mono">*</span>
                    Influencers must be registered with the Tama Platform
                </div>
                <div className="text-lg font-bold text-gray-800">
                    Total Estimated Tokens: <span className="text-emerald-600 ml-1">{totalToken}</span>
                </div>
            </div>

            {/* {infError && (
                <div className="mt-2 text-sm text-red-600 font-medium">
                    Please enter handle and hashtag for all added influencers
                </div>
            )} */}
        </div>
    );
}
